import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { loadGoogleTagScript, initializeGoogleTag, trackPageView } from '../utils/googleTag';

/**
 * GoogleTag component for integrating Google Tag (gtag.js) with React Router
 * This component:
 * 1. Loads the Google Tag script on mount
 * 2. Initializes Google Tag configuration
 * 3. Tracks page views on route changes
 */
export const GoogleTag: React.FC = () => {
  const location = useLocation();

  // Initialize Google Tag on component mount
  useEffect(() => {
    const initGoogleTag = async () => {
      try {
        // Load the Google Tag script
        await loadGoogleTagScript();
        
        // Initialize Google Tag
        initializeGoogleTag();
        
        // Track the initial page view
        trackPageView(location.pathname + location.search, document.title);
      } catch (error) {
        console.error('Error initializing Google Tag:', error);
      }
    };

    initGoogleTag();
  }, []); // Only run once on mount

  // Track page views on route changes
  useEffect(() => {
    // Don't track on initial mount (already tracked above)
    if (location.pathname) {
      trackPageView(
        location.pathname + location.search,
        document.title
      );
    }
  }, [location]); // Run whenever location changes

  // This component doesn't render anything
  return null;
};

export default GoogleTag;